import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface PublicConfig {
  beta: boolean;
  maintenanceMode: boolean;
  apiVersion: string;
  featureAccess?: Partial<Record<string, string>>;
}

interface ConfigResponse {
  config: PublicConfig;
}

export function useConfig() {
  return useQuery({
    queryKey: ['config'],
    queryFn: async () => {
      const res = await api.get<ConfigResponse>('/config');
      return res.config;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
